import { H5 } from '@/components';
import { PublicArrowRightOutlined } from 'notta-web-icon';
import React from 'react';
import NewsTag, { NewsType } from '../tags';
import * as styles from './index.module.less';

export interface NewsItemProp {
  date: string;
  type: NewsType;
  title: string;
  link: string;
}

interface IProp {
  data: NewsItemProp;
}

const NewsItem = ({ data }: IProp) => {
  const { link, date, type, title } = data;
  return (
    <a href={'/' + link} className={styles.news_link}>
      <div className={styles.news_item_container}>
        <div className={styles.date_tag_container}>
          <p className={styles.date_container}>{date?.split(' ')?.[0]}</p>
          <NewsTag tagType={type} />
        </div>
        <div className={styles.title_arrow_container}>
          <H5>{title}</H5>
          <PublicArrowRightOutlined />
        </div>
      </div>
    </a>
  );
};
export default NewsItem;
